module.exports = __webpack_public_path__ + "static/media/cert_8.bcac53b5.jpg";